"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageUploadInputSchema = exports.default = void 0;
var ImageUploadInput_1 = require("./ImageUploadInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(ImageUploadInput_1).default; } });
Object.defineProperty(exports, "imageUploadInputSchema", { enumerable: true, get: function () { return ImageUploadInput_1.imageUploadInputSchema; } });
//# sourceMappingURL=index.js.map